<template>
  <div class="wl-peixun-manager">
    <div class="yk-wrap-fixed wlx-site-manager-wrapper">
      <!-- <h3 class="text-title">培训管理</h3> -->
      <header class="site-manager-head-con">
        <el-form :inline="true">
          <el-form-item style="margin-top: 10px;">
            <el-input v-model="sTitle" placeholder="请输标题" clearable></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 10px;">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-form-item>
          <el-form-item style="margin-top: 10px;">
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
          </el-form-item>
        </el-form>
        <!-- 新增培训 -->
        <el-dialog
          title="新增培训"
          :visible.sync="addNewNoticeVisible"
          :before-close="cancel"
          :append-to-body="true"
          width="70%"
          :close-on-click-modal="false"
        >
          <div>
            <el-form ref="ruleForm" label-width="80px">
              <el-form-item label="培训标题" prop="title">
                <el-input v-model="title"></el-input>
              </el-form-item>
              <el-form-item label="培训内容">
                <Editor v-model="content" placeholder="请输入内容" />
              </el-form-item>
              <el-form-item label="开始时间">
                <el-date-picker v-model="StartTime" type="date" placeholder="选择开始时间"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间">
                <el-date-picker v-model="EndTime" type="date" placeholder="选择结束时间"></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="addSpecial()">确 定</el-button>
          </span>
        </el-dialog>
        <!--编辑-->
        <el-dialog
          title="编辑培训"
          :visible.sync="editNoticeVisible"
          :before-close="cancel"
          width="70%"
          :close-on-click-modal="false"
          :append-to-body="true"
        >
          <div>
            <el-form ref="ruleForm" label-width="80px">
              <el-form-item label="培训标题" prop="title">
                <el-input v-model="title"></el-input>
              </el-form-item>
              <el-form-item label="培训内容">
                <Editor v-model="content" placeholder="请输入内容" />
              </el-form-item>
              <el-form-item label="开始时间">
                <el-date-picker v-model="StartTime" type="date" placeholder="选择开始时间"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间">
                <el-date-picker v-model="EndTime" type="date" placeholder="选择结束时间"></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="editSpecial()">确 定</el-button>
          </span>
        </el-dialog>
      </header>
      <div>
        <el-table
          ref="multipleeeeTable"
          :data="list"
          tooltip-effect="dark"
          empty-text=" "
          style="width: 100%;margin-left:30px;"
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column prop="id"
                          type="selection"
                          width="55">
          </el-table-column>-->
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="title" label="培训标题" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="dateCreated" label="创建时间" width="200"></el-table-column>state
          <el-table-column prop="dateCreated" label="状态" width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.state == 0">未开始</span>
              <span v-else-if="scope.row.state == 1">进行中</span>
              <span v-else-if="scope.row.state == 2">已结束</span>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开始时间" width="200"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" width="200"></el-table-column>
          <el-table-column prop="SchoolCount" label="报名总人数" width="100"></el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="开始活动" placement="top-start">
                <el-button
                  size="mini"
                  v-if="scope.row.IsAuthority ==1 && (scope.row.state == 0 || scope.row.state == 2)"
                  type="primary"
                  class="wl-icon-kaishi"
                  @click="startSpecial(scope.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="结束活动" placement="top-start">
                <el-button
                  size="mini"
                  v-if="scope.row.IsAuthority == 1 && scope.row.state == 1"
                  type="primary"
                  class="wl-icon-jieshu"
                  @click="endSpecial(scope.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                <el-button
                  size="mini"
                  v-if="scope.row.IsAuthority == 1"
                  class="el-icon-edit"
                  @click="edit(scope.row)"
                  type="primary"
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="报名详情" placement="top-start">
                <el-button
                  size="mini"
                  class="el-icon-view"
                  @click="gOView(scope.row.id)"
                  type="primary"
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="设置轮次" placement="top-start">
                <el-button
                  size="mini"
                  class="wl-icon-zhihangheyi"
                  @click="gOHotel(scope.row.id)"
                  type="primary"
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                <el-button
                  size="mini"
                  v-if="scope.row.IsAuthority == 1"
                  type="danger"
                  class="el-icon-delete"
                  @click="deleteMajor(scope.row.id)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="wl-pagination-text"
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
    </div>
    <div v-if="noDataShow" class="yk-nodata-source-content">
      <img src="~assets/images/the-last-new-nodata-imag.png" alt class="yk-prompt" />
      <div class="sp-noData" style="color:#000">暂无数据。</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      title: "",
      content: "",
      newsType: 0,
      orderNumber: 0,
      /* --------------------------------------- */
      id: "",
      ids: [],
      noDataShow: false,
      value: "",
      StartTime: "",
      EndTime: "",
      LinkUrl: ""
    };
  },
  created() {
    this.getSessionStorage();
    this.school = this.$store.state.auth.userName;
    this.getSpecialList();
  },
  methods: {
    getSpecialList() {
      var that = this;
      this.$http
        .post("/api/XOrg/SpecialActivity/getSpecialList", {
          title: this.sTitle,
          type: 2,
          applyState: -1,
          page: this.pageIndex,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
            this.cancel();

            // 参数存储本地缓存
            sessionStorage.setItem("wlx_MeetingManager_sTitle",that.sTitle);
            sessionStorage.setItem("wlx_MeetingManager_pageIndex",that.pageIndex);
            sessionStorage.setItem("wlx_MeetingManager_pageSize",that.pageSize);
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    // 获取网页缓存信息
    getSessionStorage(){
      // 获取网页缓存信息
      var sTitle = sessionStorage.getItem("wlx_MeetingManager_sTitle");
      var pageIndex = sessionStorage.getItem("wlx_MeetingManager_pageIndex");
      var pageSize = sessionStorage.getItem("wlx_MeetingManager_pageSize");
     
      if(sTitle != null&& sTitle != undefined&&sTitle!="null"&&sTitle!='undefined'){
        this.sTitle = sTitle;
      }
      if(pageIndex != null && pageIndex != undefined){
        this.pageIndex = Number(pageIndex);
      }
      if(pageSize != null && pageSize!= undefined){
        this.pageSize = Number(pageSize);
      }
    },
    onPageChangeHandler(page) {
      this.pageIndex = page;
      this.getSpecialList();
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.getSpecialList();
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.Id);
      });
    },
    cancel() {
      (this.addNewNoticeVisible = false),
        (this.editNoticeVisible = false),
        (this.title = ""),
        (this.content = ""),
        (this.StartTime = "");
      this.EndTime = "";
      this.newsType = 0;
    },
    // 开始活动
    startSpecial(id) {
      var that = this;
      this.$http
        .post("/api/XOrg/SpecialActivity/startSpecial", {
          specialId: id
        })
        .then(rst => {
          if (rst.code === 1) {
            that.$message.success(rst.msg);
            that.getSpecialList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    endSpecial(id) {
      var that = this;
      this.$http
        .post("/api/XOrg/SpecialActivity/endSpecial", {
          specialId: id
        })
        .then(rst => {
          if (rst.code === 1) {
            that.$message.success(rst.msg);
            that.getSpecialList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    addSpecial() {
      var that = this;
      this.$http
        .post("/api/XOrg/SpecialActivity/addSpecial", {
          Title: that.title,
          Content: that.content,
          type: 2,
          StartTime: that.StartTime,
          EndTime: that.EndTime,
          LinkUrl: that.LinkUrl
        })
        .then(rst => {
          if (rst.code === 1) {
            that.cancel();
            that.$message({
              showClose: true,
              message: rst.msg,
              type: "success"
            });
            that.getSpecialList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    editSpecial() {
      var that = this;
      this.$http
        .post("/api/XOrg/SpecialActivity/editSpecial", {
          id: that.schoolnewsId,
          title: that.title,
          content: that.content,
          startTime: that.StartTime,
          endTime: that.EndTime,
          linkUrl: that.LinkUrl
        })
        .then(rst => {
          if (rst.code === 1) {
            that.cancel();
            that.$message({
              message: rst.msg,
              type: "success"
            });
            that.editNoticeVisible = false;
            that.getSpecialList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    add() {
      this.addNewNoticeVisible = true;
    },
    edit(row) {
      this.editNoticeVisible = true;
      this.title = row.title;
      this.content = row.content;
      this.StartTime = row.startTime;
      this.EndTime = row.endTime;
      this.LinkUrl = row.linkUrl;
      this.schoolnewsId = row.id;
      this.newsType = row.type;
    },
    deleteMajor(id) {
      var that = this;
      this.$confirm("此操作将删除该培训, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http
            .post("/api/XOrg/SpecialActivity/deleteSpecial", {
              id: id
            })
            .then(rst => {
              if (rst.code === 1) {
                that.$message({
                  message: rst.msg,
                  type: "success"
                });
                that.getSpecialList(1);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.pageIndex = 1;
      this.getSpecialList();
    },
    gOView(id) {
      this.$router.push({
        name: "PeiXunEnrollManager",
        params: { activityId: id }
      });
    },
    gOHotel(id) {
      this.$router.push({
        name: "PeiXunPlanManager",
        params: { activityId: id }
      });
    }
  }
};
</script>

<style lang="scss">
.wl-peixun-manager {
  padding: 20px;
  background: #fff;
  .yk-wrap-fixed {
    .el-input--suffix .el-input__inner {
      padding-right: 30px;
      height: 34px;
    }
    .wl-pagination-text {
      text-align: center;
      margin-top: 30px;
    }
    .site-manager-head-con {
      text-align: right;
    }
    .el-form-item__content {
      .el-button {
        padding: 8px 15px;
      }
    }
    .sp-test-detail-title {
      padding: 0 15px;
      font-size: 16px;
      color: #2d82ff;
      // border-bottom: 2px solid #2d82ff;
      line-height: 59px;
      min-width: 30px;
      text-align: center;
    }
    .wlx-table-content {
      margin-top: 84px;
    }
  }
}
</style>
